import { render, staticRenderFns } from "./ScrollBarItem.vue?vue&type=template&id=8f90526a&scoped=true&"
import script from "./ScrollBarItem.vue?vue&type=script&lang=js&"
export * from "./ScrollBarItem.vue?vue&type=script&lang=js&"
import style0 from "./ScrollBarItem.vue?vue&type=style&index=0&id=8f90526a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f90526a",
  null
  
)

export default component.exports